/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 16/05/2025 16:53
 *
 */

import { VigiMenuItem } from '../../../model/vigi-menu-item';
import { Logger, TreeNode } from '@infodata-group/inf-commons';

export class VigiMenuItemNode extends TreeNode {
  public menuItem: VigiMenuItem;
  public override nodes: VigiMenuItemNode[];

  constructor(menuItem: VigiMenuItem) {
    super(menuItem.id, menuItem.label, menuItem.icon);
    this.menuItem = menuItem;
  }

  public addNode(menuItem: VigiMenuItem): void {
    this.menuItem.submenus.push(menuItem);
    this.nodes.push(menuItem.toVigiMenuItemNode());
  }

  public removeNode(item: VigiMenuItemNode): void {
    Logger.v(
      this.menuItem.submenus.splice(
        this.menuItem.submenus.findIndex((x) => x.id === item.id),
        1,
      ),
    );
    Logger.v(
      this.nodes.splice(
        this.nodes.findIndex((x) => x.id === item.id),
        1,
      ),
    );
  }

  // public findNode(id: string, result = []): VigiMenuItemNode[] {
  //   if (this.id === id) {
  //     result.push(this);
  //   }
  //   result = [... result, ... this.nodes.map(x => x.findNode(id)).filter(x => x !== undefined)];
  //   return result;
  // }
}
